<section class="h-screen overflow-y-auto p-4 text-white sm:p-8">
  <div class="mx-auto w-full max-w-6xl">
    <header class="grid gap-8 py-4 pb-8 sm:gap-12">
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
        <img src="assets/nSideLogoNoTagline-WHITE.png" alt="nSide" class="h-10 w-auto self-start" />
        <span class="hidden h-8 w-px bg-white/30 sm:block"></span>
        <span class="oswald-font text-2xl">Admin Tools</span>
      </div>

      <!-- <div>
        <h1 class="oswald-font m-0 max-w-3xl text-5xl leading-none">
          Choose an admin product
        </h1>
        <p class="mt-4 max-w-3xl text-sm leading-relaxed text-white/85">
          Open the product you need. Building-specific products include their own building context once selected.
        </p>
      </div> -->
    </header>

    <div class="grid grid-cols-1 gap-4 pb-4 sm:grid-cols-2 xl:grid-cols-3">
      <ng-container *ngFor="let product of products">
        <a
          *ngIf="!product.external"
          [routerLink]="product.route"
          class="flex min-h-64 flex-col justify-between gap-5 rounded-lg border border-white/70 bg-white/95 p-5 text-gray-800 no-underline shadow-custom-1 transition hover:-translate-y-0.5 hover:bg-white hover:shadow-custom-2">
          <div class="flex items-start justify-between gap-4">
            <span class="inline-flex h-14 w-14 items-center justify-center rounded-lg bg-blue-500 text-white">
              <lucide-icon [img]="product.icon" [size]="26"></lucide-icon>
            </span>
            <span
              *ngIf="product.status"
              class="rounded-md bg-indigo-100 px-2.5 py-1.5 text-xs font-bold leading-none text-indigo-700">
              {{ product.status }}
            </span>
          </div>

          <div>
            <h2 class="oswald-font mb-2 text-[1.35rem] text-gray-700">{{ product.title }}</h2>
            <p class="m-0 text-sm leading-relaxed text-gray-500">{{ product.description }}</p>
          </div>

          <span class="oswald-font inline-flex w-fit items-center gap-1.5 rounded-md bg-blue-500 px-3 py-2 text-sm text-white">
            Open
            <lucide-icon [img]="icons.ChevronRight" [size]="16"></lucide-icon>
          </span>
        </a>

        <a
          *ngIf="product.external"
          [href]="product.href"
          target="_blank"
          rel="noopener"
          class="flex min-h-64 flex-col justify-between gap-5 rounded-lg border border-white/70 bg-white/95 p-5 text-gray-800 no-underline shadow-custom-1 transition hover:-translate-y-0.5 hover:bg-white hover:shadow-custom-2">
          <div class="flex items-start justify-between gap-4">
            <span class="inline-flex h-14 w-14 items-center justify-center rounded-lg bg-blue-500 text-white">
              <lucide-icon [img]="product.icon" [size]="26"></lucide-icon>
            </span>
            <span
              *ngIf="product.status"
              class="rounded-md bg-indigo-100 px-2.5 py-1.5 text-xs font-bold leading-none text-indigo-700">
              {{ product.status }}
            </span>
          </div>

          <div>
            <h2 class="oswald-font mb-2 text-[1.35rem] text-gray-700">{{ product.title }}</h2>
            <p class="m-0 text-sm leading-relaxed text-gray-500">{{ product.description }}</p>
          </div>

          <span class="oswald-font inline-flex w-fit items-center gap-1.5 rounded-md bg-blue-500 px-3 py-2 text-sm text-white">
            Open
            <lucide-icon [img]="icons.ChevronRight" [size]="16"></lucide-icon>
          </span>
        </a>
      </ng-container>
    </div>
  </div>
</section>
